var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "report-main" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "report-content" }, [
      _c("div", { staticClass: "pdf-tit center-box" }, [
        _vm._v("Property Campaign Report")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pdf-time center-box" }, [
        _vm._v(
          _vm._s(_vm.pdfTimeShow ? "(" + _vm.pdfTimeShow + ")" : "-") + "\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "property-infoBox" }, [
        _c("div", { staticClass: "property-imgBox" }, [
          _c("img", {
            staticClass: "property-imgBox",
            attrs: {
              crossorigin: "anonymous",
              src:
                _vm.propertyPdfInfo.propertyImg +
                "?time=" +
                new Date().getTime(),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("img", {
            staticClass: "property-icon",
            attrs: {
              crossorigin: "anonymous",
              src:
                _vm.propertyPdfInfo.houseInfo.companyLogoUrl +
                "?time=" +
                new Date().getTime()
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-info" }, [
          _c("p", { staticClass: "property-type" }, [
            _vm._v(
              _vm._s(
                _vm.propertyPdfInfo.housePropertyInfoPojo.proertyType
                  ? _vm.propertyPdfInfo.housePropertyInfoPojo.proertyType
                  : "House & Land"
              )
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "addressText" }, [
            _vm._v(
              "\n          " +
                _vm._s(
                  _vm.propertyPdfInfo.houseInfo.address
                    ? _vm.propertyPdfInfo.houseInfo.address + ", "
                    : ""
                ) +
                " " +
                _vm._s(_vm.propertyPdfInfo.houseInfo.suburb) +
                " " +
                _vm._s(_vm.propertyPdfInfo.houseInfo.state) +
                " " +
                _vm._s(_vm.propertyPdfInfo.houseInfo.postcode) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "primaryText",
              staticStyle: { "font-size": "20px" }
            },
            [
              _vm._v(
                "$" +
                  _vm._s(_vm.propertyPdfInfo.houseInfo.price) +
                  " " +
                  _vm._s(
                    _vm.propertyPdfInfo.houseInfo.maxPrice
                      ? "- $" + _vm.propertyPdfInfo.houseInfo.maxPrice
                      : ""
                  )
              )
            ]
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "lineBox",
            staticStyle: { margin: "15px 0" }
          }),
          _vm._v(" "),
          _vm.propertyPdfInfo.housePropertyInfoPojo.proertyType !== "Land"
            ? _c("div", { staticClass: "house-info" }, [
                _c("div", { staticClass: "flex-box housevalueBox" }, [
                  _c("span", { staticClass: "label-box primaryText" }, [
                    _vm._v("Estimated Commencement")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value-box primaryText" }, [
                    _vm._v(
                      _vm._s(
                        _vm.propertyPdfInfo.houseInfo.estimatedCommenceMent
                          ? _vm.propertyPdfInfo.houseInfo.estimatedCommenceMent
                          : "-"
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex-box housevalueBox" }, [
                  _c("span", { staticClass: "label-box primaryText" }, [
                    _vm._v("Estimated Completion")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value-box primaryText" }, [
                    _vm._v(
                      _vm._s(
                        _vm.propertyPdfInfo.houseInfo.estimatedCompletion
                          ? _vm.propertyPdfInfo.houseInfo.estimatedCompletion
                          : "-"
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex-box housevalueBox" }, [
                  _c("span", { staticClass: "label-box primaryText" }, [
                    _vm._v("Contract Type")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value-box primaryText" }, [
                    _vm._v(
                      _vm._s(
                        _vm.propertyPdfInfo.houseInfo.contractType
                          ? _vm.propertyPdfInfo.houseInfo.contractType
                          : "-"
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex-box housevalueBox" }, [
                  _c("span", { staticClass: "label-box primaryText" }, [
                    _vm._v("Estimated Rental (per week)")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value-box primaryText" }, [
                    _vm._v(
                      "$" +
                        _vm._s(
                          _vm.propertyPdfInfo.houseInfo.rental
                            ? _vm.propertyPdfInfo.houseInfo.rental
                            : "0"
                        ) +
                        " - $" +
                        _vm._s(
                          _vm.propertyPdfInfo.houseInfo.maxRental
                            ? _vm.propertyPdfInfo.houseInfo.maxRental
                            : "0"
                        )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex-box housevalueBox" }, [
                  _c("span", { staticClass: "label-box primaryText" }, [
                    _vm._v("Incentives")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value-box primaryText" }, [
                    _vm._v(
                      _vm._s(
                        _vm.propertyPdfInfo.houseInfo.incentives
                          ? _vm.propertyPdfInfo.houseInfo.incentives
                          : "-"
                      )
                    )
                  ])
                ])
              ])
            : _c("div", { staticClass: "house-info" }, [
                _c("div", { staticClass: "flex-box housevalueBox" }, [
                  _c("span", { staticClass: "label-box primaryText" }, [
                    _vm._v("Estimated Settlement")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value-box primaryText" }, [
                    _vm._v(
                      _vm._s(
                        _vm.propertyPdfInfo.houseInfo.estimatedSettled
                          ? _vm.propertyPdfInfo.houseInfo.estimatedSettled
                          : "-"
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex-box housevalueBox" }, [
                  _c("span", { staticClass: "label-box primaryText" }, [
                    _vm._v("Titles Iessued")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value-box primaryText" }, [
                    _vm._v(
                      _vm._s(
                        _vm.propertyPdfInfo.houseInfo.titlesIssued
                          ? _vm.propertyPdfInfo.houseInfo.titlesIssued
                          : "-"
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex-box housevalueBox" }, [
                  _c("span", { staticClass: "label-box primaryText" }, [
                    _vm._v("Land Size")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value-box primaryText" }, [
                    _vm._v(
                      _vm._s(
                        _vm.propertyPdfInfo.houseInfo.labdSize
                          ? _vm.propertyPdfInfo.houseInfo.labdSize
                          : "0"
                      ) +
                        "m² " +
                        _vm._s(
                          _vm.propertyPdfInfo.houseInfo.landSizeMax
                            ? "- " +
                                _vm.propertyPdfInfo.houseInfo.landSizeMax +
                                "m²"
                            : ""
                        )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex-box housevalueBox" }, [
                  _c("span", { staticClass: "label-box primaryText" }, [
                    _vm._v("Contract Type")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value-box primaryText" }, [
                    _vm._v(
                      _vm._s(
                        _vm.propertyPdfInfo.houseInfo.contractType
                          ? _vm.propertyPdfInfo.houseInfo.contractType
                          : "-"
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex-box housevalueBox" }, [
                  _c("span", { staticClass: "label-box primaryText" }, [
                    _vm._v("Incentives")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value-box primaryText" }, [
                    _vm._v(
                      _vm._s(
                        _vm.propertyPdfInfo.houseInfo.incentives
                          ? _vm.propertyPdfInfo.houseInfo.incentives
                          : "-"
                      )
                    )
                  ])
                ])
              ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "lineBox", staticStyle: { margin: "40px 0" } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "broker-list" },
        _vm._l(_vm.propertyPdfInfo.agentList, function(item, i) {
          return _c("div", { key: i, staticClass: "broker-item" }, [
            _c("img", {
              staticClass: "userImg",
              attrs: {
                crossorigin: "anonymous",
                src: item.agentImageUrl1 + "?time=" + Date.now(),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("div", [
              _c("img", {
                staticClass: "user-icon",
                attrs: {
                  crossorigin: "anonymous",
                  src:
                    _vm.propertyPdfInfo.houseInfo.companyLogoUrl +
                    "?time=" +
                    Date.now()
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "user-name" }, [
                _vm._v(
                  _vm._s(item.agentFirstName1) +
                    " " +
                    _vm._s(item.agentLastName1)
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "primaryText" }, [
                _vm._v(_vm._s(item.agentMobile1))
              ])
            ])
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "lineBox",
        staticStyle: { margin: "0 0 40px 0" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "statistics-list" }, [
        _c("div", { staticClass: "statistics-card" }, [
          _c("div", { staticClass: "sta-label" }, [_vm._v("Views")]),
          _vm._v(" "),
          _c("div", { staticClass: "num-box" }, [
            _vm._v(_vm._s(_vm.propertyPdfInfo.actionsLogStatics.views))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "statistics-card" }, [
          _c("div", { staticClass: "sta-label" }, [_vm._v("Search Results")]),
          _vm._v(" "),
          _c("div", { staticClass: "num-box" }, [
            _vm._v(_vm._s(_vm.propertyPdfInfo.actionsLogStatics.searchResults))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "statistics-card" }, [
          _c("div", { staticClass: "sta-label" }, [_vm._v("Details Clicks")]),
          _vm._v(" "),
          _c("div", { staticClass: "num-box" }, [
            _vm._v(_vm._s(_vm.propertyPdfInfo.actionsLogStatics.detailsClicks))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "statistics-card" }, [
          _c("div", { staticClass: "sta-label" }, [_vm._v("Time on Page")]),
          _vm._v(" "),
          _c("div", { staticClass: "num-box" }, [
            _vm._v(
              _vm._s(_vm.propertyPdfInfo.actionsLogStatics.timeOnPage) +
                "\n          " +
                _vm._s(
                  _vm.propertyPdfInfo.actionsLogStatics.timeOnPage > 1
                    ? "mins"
                    : "min"
                )
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "statistics-card" }, [
          _c("div", { staticClass: "sta-label" }, [
            _vm._v("Select Now Clicks")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "num-box" }, [
            _vm._v(
              _vm._s(_vm.propertyPdfInfo.actionsLogStatics.selectNowClicks)
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "statistics-card" }, [
          _c("div", { staticClass: "sta-label" }, [_vm._v("Phone Clicks")]),
          _vm._v(" "),
          _c("div", { staticClass: "num-box" }, [
            _vm._v(_vm._s(_vm.propertyPdfInfo.actionsLogStatics.phoneClicks))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "statistics-card" }, [
          _c("div", { staticClass: "sta-label" }, [_vm._v("Favourited")]),
          _vm._v(" "),
          _c("div", { staticClass: "num-box" }, [
            _vm._v(_vm._s(_vm.propertyPdfInfo.actionsLogStatics.favourited))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "statistics-card" }, [
          _c("div", { staticClass: "sta-label" }, [_vm._v("Shares")]),
          _vm._v(" "),
          _c("div", { staticClass: "num-box" }, [
            _vm._v(_vm._s(_vm.propertyPdfInfo.actionsLogStatics.shares))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "lineBox",
        staticStyle: { margin: "0 0 40px 0" }
      }),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "lineBox", staticStyle: { margin: "40px 0" } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "flex-box",
          staticStyle: { "justify-content": "space-between" }
        },
        [
          _c("div", { staticClass: "bar-box" }, [
            _c("div", { staticClass: "chart-tip" }, [_vm._v("Tab Views")]),
            _vm._v(" "),
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: this.propertyPdfInfo.tabBarXData.length,
                  expression: "this.propertyPdfInfo.tabBarXData.length"
                }
              ],
              style: {
                height: this.propertyPdfInfo.tabViewStaticsLength
                  ? this.propertyPdfInfo.tabViewStaticsLength * 55 + "px"
                  : "auto"
              },
              attrs: { id: "bar-chart" }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !this.propertyPdfInfo.tabBarXData.length,
                    expression: "!this.propertyPdfInfo.tabBarXData.length"
                  }
                ],
                staticClass: "empty-text"
              },
              [_vm._v("No data yet")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bar-box" }, [
            _c("div", { staticClass: "chart-tip" }, [_vm._v("Time on Tab")]),
            _vm._v(" "),
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: this.propertyPdfInfo.tabBarXData1.length,
                  expression: "this.propertyPdfInfo.tabBarXData1.length"
                }
              ],
              style: {
                height: this.propertyPdfInfo.timeOnTabLength
                  ? this.propertyPdfInfo.timeOnTabLength * 55 + "px"
                  : "auto"
              },
              attrs: { id: "bar-chartTwo" }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !this.propertyPdfInfo.tabBarXData1.length,
                    expression: "!this.propertyPdfInfo.tabBarXData1.length"
                  }
                ],
                staticClass: "empty-text"
              },
              [_vm._v("No data yet")]
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "topBox" }, [
      _c("img", {
        staticClass: "report-logo",
        attrs: { src: require("../../../static/img/UNIFI_LOGO.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "line-chart" }, [
      _c("div", { staticClass: "chart-tip" }, [_vm._v("Views")]),
      _vm._v(" "),
      _c("div", { attrs: { id: "line-chart" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e3d89af", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e3d89af","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/listing/report.vue
// module id = null
// module chunks = 